import { ReactNode } from 'react';

import Typography from '../../../../../components/Typography';
import WarningIcon from '../../../../../icons/WarningIcon';
import { Root } from './styles';

export interface NotificationProps {
  children: ReactNode;
  className?: string;
}

const Notification = ({ children, className }: NotificationProps) => {
  return (
    <Root className={className}>
      <WarningIcon size={24} color="warning.400" />
      <Typography variant="paragraphMedium" color="warning.400" sx={{ fontVariantNumeric: 'tabular-nums' }}>
        {children}
      </Typography>
    </Root>
  );
};

export default Notification;
